export default "__VITE_ASSET__D9TjPBuC__"